export enum OrderWorkflowNode {
  SelectTeeth = 1,
  SelectArch = 2,
  DesignStyle = 3,
  TreatmentInfo = 4,
  TreatmentInfoAdvanced = 5,
  ReviewAndSubmit,
}
